import React from 'react';

function Sort({applySort, sortForm, handleSortChange}) {
    
    return (
        <div>
            <div className='mt-2'>Milestone Name</div>
            <div className='d-flex'>
                <div className="form-check">
                    <input 
                        className="form-check-input" 
                        type="radio" 
                        name="form" 
                        id="nameAsc"
                        defaultChecked={sortForm?.name === "ASC"} 
                        onChange={()=>handleSortChange({name: "ASC"})}/>
                    <label className="form-check-label" htmlFor="nameAsc">
                        Ascending
                    </label>
                </div>
                <div className="form-check ms-3">
                    <input 
                        className="form-check-input" 
                        type="radio" 
                        name="form" 
                        id="nameDesc" 
                        defaultChecked={sortForm?.name === "DESC"}
                        onChange={()=>handleSortChange({name: "DESC"})}/>
                    <label className="form-check-label" htmlFor="nameDesc">
                        Descending
                    </label>
                </div>
            </div>
            <div className='mt-2'>Created At</div>
            <div className='d-flex'>
                <div className="form-check">
                    <input 
                        className="form-check-input" 
                        type="radio" 
                        name="form" 
                        id="createdAtAsc"
                        defaultChecked={sortForm?.created_at === "ASC"} 
                        onChange={()=>handleSortChange({created_at: "ASC"})}/>
                    <label className="form-check-label" htmlFor="createdAtAsc">
                        Oldest First
                    </label>
                </div>
                <div className="form-check ms-3">
                    <input 
                        className="form-check-input" 
                        type="radio" 
                        name="form" 
                        id="createdAtDesc" 
                        defaultChecked={sortForm?.created_at === "DESC"}
                        onChange={()=>handleSortChange({created_at: "DESC"})}/>
                    <label className="form-check-label" htmlFor="createdAtDesc">
                        Recent First
                    </label>
                </div>
            </div>
            <div className='d-flex' style={{justifyContent: "center"}}>
                <div 
                    onClick={applySort} 
                    className="btn btn-success common-button" style={{width: "90%"}}>Apply</div>
            </div>
        </div>
        
    );
}

export default Sort;